import _ from 'lodash'
import core from '../../core'

import { valueTable as commonConfigValues } from './commonConfig'

const { theirRole } = commonConfigValues

const { helpers: { keepInLength, getLoginFromMail, getUserId } } = core

const styles = {
  floatingLabel: { fontSize: '1.1rem' },
  fieldText: { fontSize: '0.8rem' }
}

export const sourceType = [
  { id: 1, label: 'Centre Staff Meeting' },
  { id: 2, label: 'Child in Care Review' },
  { id: 3, label: 'Court Hearing' },
  { id: 4, label: 'HIQA Recommendation' },
  { id: 5, label: 'Monitoring Recommendation' },
  { id: 6, label: 'Operational - Management' },
  { id: 7, label: 'Operational - Staff' },
  { id: 8, label: 'Professional Advice' },
  { id: 9, label: 'Professional / Strategy Meeting' },
  { id: 10, label: 'Referral Meeting' },
  { id: 11, label: 'Other' }
]

export const decisionStatus = [
  { id: 1, label: 'Interim Operational Staff Decision' },
  { id: 2, label: 'Management Endorsed Decision' },
  { id: 3, label: 'Decision Withdrawn by Management' }
]

export const valueTable = {
  sourceType,
  decisionStatus
}

export const views = [
  {
    id: 1,
    viewName: 'QuickView',
    columns: [
      'person.fullName',
      'decision.date',
      'decision.notes',
      'decision.sourceType',
      'decision.status',
      'decision.validFrom'
    ]
  }
]

export const columns = [
  {
    name: 'id',
    title: 'ID',
    hidden: true,
    formField: true
  },
  {
    name: 'register.personId',
    title: 'YP UI',
    minSpace: 'YP UIw ',
    formField: true
  },
  {
    name: 'register.person.firstName',
    title: 'YP First Name',
    hidden: true,
    minSpace: 'YP ',
    formField: true
  },
  {
    name: 'register.person.lastName',
    title: 'YP Last Name',
    hidden: true,
    minSpace: 'YP ',
    formField: true
  },
  {
    name: 'register.person.fullName',
    title: 'YP Name',
    formField: true,
    getCellValue: row =>
      `${row['register.person.firstName']} ${row['register.person.lastName']}`,
    maxChars: 100,
    minSpace: 'YP Name '
  },
  {
    name: 'decision.date',
    title: 'Decision Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Decision '
  },
  {
    name: 'decision.time',
    title: 'Decision Time',
    formField: true,
    type: 'time',
    filterField: true,
    minSpace: 'Decision '
  },
  {
    name: 'decision.notes',
    title: 'Decision Notes',
    formField: true,
    maxChars: 300,
    filterField: true,
    minSpace: 'Decision '
  },
  {
    name: 'decision.sourceType',
    title: 'Decision Source Type',
    formField: true,
    type: 'select',
    multiple: true,
    getCellValue: row =>
      _.find(sourceType, ['id', parseInt(row[`decision.sourceType`], 10)])
        ? _.find(sourceType, ['id', parseInt(row[`decision.sourceType`], 10)])
            .label
        : row[`decision.sourceType`],
    options: 'sourceType',
    filterField: true,
    minSpace: 'Source Type '
  },
  {
    name: 'decision.requested',
    title: 'Decision Requested / Recommended By Name(s)',
    formField: true,
    maxChars: 100,
    minSpace: 'Recommended By Name(s) '
  },
  {
    name: 'decision.theirRoleRequested',
    title: 'Their Role(s)',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(theirRole, [
        'id',
        parseInt(row[`decision.theirRoleRequested`], 10)
      ])
        ? _.find(theirRole, [
            'id',
            parseInt(row[`decision.theirRoleRequested`], 10)
          ]).label
        : row[`decision.theirRoleRequested`],
    options: 'theirRole',
    filterField: true,
    minSpace: 'Role(s) '
  },
  {
    name: 'decision.decisionsMade',
    title: 'Decision Made by Name(s)',
    formField: true,
    maxChars: 50,
    minSpace: 'Decision Made '
  },
  {
    name: 'decision.theirRoleMade',
    title: 'Their Role(s)',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(theirRole, ['id', parseInt(row[`decision.theirRoleMade`], 10)])
        ? _.find(theirRole, ['id', parseInt(row[`decision.theirRoleMade`], 10)])
            .label
        : row[`decision.theirRoleMade`],
    options: 'theirRole',
    filterField: true,
    minSpace: 'Role(s) '
  },
  {
    name: 'decision.status',
    title: 'Decision Status',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(decisionStatus, ['id', parseInt(row[`decision.status`], 10)])
        ? _.find(decisionStatus, ['id', parseInt(row[`decision.status`], 10)])
            .label
        : row[`decision.status`],
    options: 'decisionStatus',
    filterField: true,
    minSpace: 'Decision '
  },
  {
    name: 'decision.validFrom',
    title: 'Decision Status Valid at Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Decision Status '
  }
]

export const getSubForms = ({
  data: { centres, persons, reasons },
  fields,
  change,
  formName,
  showAsterix,
  openToYearSelection,
  hideCalendarDate,
  disabled,
  add,
  formValues,
  proceedSelectionChange,
  personAdd,
  availableValues
}) => {
  const forms = [
    {
      id: 1,
      name: 'reg',
      activeName: 'decision',
      historyName: 'decisionHistory',
      label: 'Register',
      icon: 'note',
      fields: [
        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'registerId',
          disabled: !add,
          label: 'Register Entry',
          required: showAsterix,
          validate: v => (v ? undefined : 'Field is required'),
          options: availableValues.register.filter(f => f.id > 0).map(o => {
            const person = _.find(availableValues.persons, ['id', o.personId])
            const label = `${person.firstName} ${person.lastName} (register: ${
              o.id
            })`
            return { value: o.id, label: label }
          })
        }
      ]
    },
    {
      id: 2,
      name: 'dec',
      activeName: 'decision',
      historyName: 'decisionHistory',
      label: 'Decisions',
      icon: 'note',
      fields: [
        [
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'decision.date',
            label: 'Decision Date',
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v => (v ? undefined : 'Field is required')
          },
          {
            type: fields.timepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'decision.time',
            label: 'Decision Time',
            required: showAsterix,
            minutesStep: 1,
            // openToYearSelection: openToYearSelection,
            //hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v => (v ? undefined : 'Field is required')
          }
        ],
        {
          type: fields.text,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          rows: 1,
          maxRows: 10,
          required: showAsterix,
          name: 'decision.notes',
          label: 'Decision Notes',
          normalize: v => {
            const val = keepInLength(v, 300)
            return val
          },
          validate: v => (v ? undefined : 'Field is required')
        },
        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'decision.sourceType',
          label: 'Decision Source Type',
          multiple: true,
          required: showAsterix,
          validate: v => (v ? undefined : 'Field is required'),
          options: availableValues.sourceType.filter(f => f.id > 0).map(o => {
            return { value: o.id, label: o.label }
          })
        },
        [
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            required: showAsterix,
            name: 'decision.requested',
            label: 'Decision Requested / Recommended By Name(s)',
            normalize: v => {
              const val = keepInLength(v, 100)
              return val
            },
            validate: v => (v ? undefined : 'Field is required')
          },
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'decision.theirRoleRequested',
            label: 'Their Role(s)',
            disabled: true,
            required: showAsterix,
            validate: v => (v ? undefined : 'Field is required'),
            options: availableValues.theirRole.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            })
          }
        ],
        [
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            required: showAsterix,
            name: 'decision.decisionsMade',
            label: 'Decision Made by Name(s)',
            normalize: v => {
              const val = keepInLength(v, 50)
              return val
            },
            validate: v => (v ? undefined : 'Field is required')
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'decision.theirRoleMade',
            label: 'Their Role(s)',
            disabled: true,
            required: showAsterix,
            validate: v => (v ? undefined : 'Field is required'),
            options: availableValues.theirRole.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            })
          }
        ],
        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'decision.status',
          label: 'Decision Status',
          // multiple: true,
          required: showAsterix,
          validate: v => (v ? undefined : 'Field is required'),
          options: valueTable.decisionStatus.filter(f => f.id > 0).map(o => {
            return { value: o.id, label: o.label }
          })
        },
        {
          type: fields.datepicker,
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'decision.validFrom',
          label: 'Decision Status Valid at Date',
          required: showAsterix,
          openToYearSelection: openToYearSelection,
          hideCalendarDate: hideCalendarDate,
          textFieldStyle: { width: '100%', ...styles.fieldText },
          validate: v => (v ? undefined : 'Field is required')
        }
      ]
    }
  ]

  return forms
}

export const activeSection = ['decision']

export const errors = [1, 2]

export const defaultNew = {
  decision: {
    historyId: 'new',
    audit: {
      active: true,
      modifiedBy: getLoginFromMail(getUserId()),
      modifiedDate: new Date()
    }
  },
  decisionHistory: []
}

// "decisions": [
//   {
// "decision": {
//   "id": 1,
//   "registerId": 1, //  ->  "personId": 2 -> person,
//   "date": "2001-01-01T23:28:56.782Z",
//   "time": "T23:28:56.782Z",
//   "notes": "aaa",
//   "sourceType": 2,
//   "requested": "daa",
//   "theirRoleRequested" : 2,
//   "decisionsMade" :2,
//   "theirRoleMade": 2,
//   "status": 1,
//   "validFrom": "2001-01-01T23:28:56.782Z"
// },
// "decisionHistory": {

// }
//   }
// ]



// WEBPACK FOOTER //
// ./src/register/configs/decisions.js